import service from "@irati-tracking/tracker"

const tracking = {
  viewRewardWallet: () => {
    service.trackWalletEvent("wallet_reward_view")
  },

  clickRewardWalletTab: () => {
    service.trackWalletEvent("wallet_reward_tab_click")
  },

  clickCompanyRewardWalletsTab: () => {
    service.trackWalletEvent("wallet_company_reward_tab_click")
  },

  startRewardWalletSendCredit: () => {
    service.trackWalletEvent("wallet_send_credit")
  },

  clickRewardWallet: () => {
    service.trackWalletEvent("wallet_view_reward_wallet")
  },

  clickRewardShowMore: () => {
    service.trackWalletEvent("wallet_r_show_more")
  },

  clickBrowseRewards: () => {
    service.trackWalletEvent("wallet_browse rewards")
  },

  clickDenominationDropdown: () => {
    service.trackWalletEvent("wallet_send_credit_denomination_drop_down")
  },

  updateDenominationDropdown: () => {
    service.trackWalletEvent("wallet_send_credit_select_denomination")
  },

  clickRewardWithCredit: () => {
    service.trackWalletEvent("wallet_send_credit_reward_with_credit")
  },

  clickGiveThisReward: () => {
    service.trackWalletEvent("wallet_send_credit_give_this_reward")
  },

  clickUserDropdown: () => {
    service.trackWalletEvent("wallet_send_credit_user_drop_down")
  },

  selectUser: () => {
    service.trackWalletEvent("wallet_send_credit_select_user")
  },

  clickContinueToMessage: () => {
    service.trackWalletEvent("wallet_send_credit_continue_to_message")
  },

  updateMessage: () => {
    service.trackWalletEvent("wallet_send_credit_add_message")
  },

  clickCompanyValueDropdown: () => {
    service.trackWalletEvent("wallet_send_credit_company_value_drop_down")
  },

  selectCompanyValue: () => {
    service.trackWalletEvent("wallet_send_credit_select_company_value")
  },

  clickSharePermissions: () => {
    service.trackWalletEvent("wallet_send_credit_share_with_drop_down")
  },

  selectPermission: () => {
    service.trackWalletEvent("wallet_send_credit_select_share_with")
  },

  backToRecipient: () => {
    service.trackWalletEvent("wallet_send_credit_back_to_recipient")
  },

  clickContinueToCheckout: () => {
    service.trackWalletEvent("wallet_send_credit_continue_to_checkout")
  },

  backToMessage: () => {
    service.trackWalletEvent("wallet_send_credit_back_to_message")
  },

  clickPay: () => {
    service.trackWalletEvent("wallet_send_credit_pay_&_send")
  },

  clickDenominationDropdownCheckout: () => {
    service.trackWalletEvent("wallet_send_credit_checkout_denomination_drop_down")
  },

  selectDenominationCheckout: () => {
    service.trackWalletEvent("wallet_send_credit_checkout_select_denomination")
  },

  clearReward: () => {
    service.trackWalletEvent("wallet_send_credit_checkout_clear_reward")
  },

  continueToPay: () => {
    service.trackWalletEvent("wallet_continue_&_pay")
  },

  useCredit: () => {
    service.trackWalletEvent("wallet_use_credit")
  },

  rewardWalletClick: (type: string) => {
    service.trackWalletEvent("reward_wallet_click", {type, source: "template"})
  }
}
export default tracking
